import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { SiZalo } from "react-icons/si";
import { X } from "lucide-react";

const ZALO_LINK = "https://zalo.me/84832240483";

export const ZaloButton = () => {
  const [open, setOpen] = useState(false);
  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3">
      <AnimatePresence>
        {open && (
          <motion.div initial={{ opacity: 0, y: 12, scale: 0.9 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 12, scale: 0.9 }}
            className="bg-white rounded-2xl shadow-lift border border-slate-200 p-4 w-64" data-testid="zalo-popup">
            <div className="flex items-center justify-between mb-2">
              <span className="font-semibold text-brand-navy text-sm flex items-center gap-2"><SiZalo className="w-5 h-5 text-[#0068FF]" /> Zalo Chat</span>
              <button onClick={() => setOpen(false)} className="text-slate-400 hover:text-slate-700"><X className="w-4 h-4" /></button>
            </div>
            <p className="text-xs text-slate-500 mb-3">Message our immigration consultants directly on Zalo for a quick response.</p>
            <a href={ZALO_LINK} target="_blank" rel="noopener noreferrer" data-testid="zalo-open-chat"
              className="block text-center text-sm font-semibold text-white bg-[#0068FF] rounded-lg py-2.5 hover:bg-[#0055d4] transition-colors">
              Open Zalo
            </a>
          </motion.div>
        )}
      </AnimatePresence>
      <button onClick={() => setOpen((v) => !v)} aria-label="Chat on Zalo" data-testid="zalo-fab"
        className="w-14 h-14 rounded-full bg-[#0068FF] text-white shadow-lift flex items-center justify-center hover:scale-105 transition-transform animate-float-slow">
        <SiZalo className="w-7 h-7" />
      </button>
    </div>
  );
};
